import { siteInfoTypes as actionTypes } from '@actions';
import { commonState, commonReducer } from '@dotone/react-ui-core/helpers';

const defaultState = {
  ...commonState.default(),
};

export const siteInfoImpressions = (state = defaultState, action) =>
  commonReducer(actionTypes.GET_SITE_INFO_IMPRESSIONS, state, action);
